const initialState = {
  labelMonth: "Januari",
  monFilter: 1,
};

export default function main(state = initialState, action) {
  switch (action.type) {
    case "GET_DATA_USER":
      return {
        ...state,
        dataUser: action.data,
      };
    case "GET_FILTER_MONTH":
      return {
        ...state,
        monFilter: action.monFilter,
        labelMonth: action.labelMonth,
        pathUrl: action.pathUrl,
      };
    case "GET_PATH_URL":
      return {
        ...state,
        pathUrl: action.pathUrl,
      };
    case "GET_DATA_MONTH":
      return {
        ...state,
        dataMonth: action.data,
      };
    case "GET_FILTER_YEAR":
      return {
        ...state,
        yearFilter: action.data,
      };
    case "GET_FILTER_PERUSAHAAN":
      return {
        ...state,
        perusahaanFilter: action.data,
      };
    default:
      return state;
  }
}
